export enum ShowAds {
  DONT_SHOW_ADS,
  SHOW_ADS
}
